var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpiId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "8 6 8 12",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.16 17 2.835-10 2.63 4.985z",
    fill: "#028c3c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.375 17 2.835-10 2.63 4.985z",
    fill: "#fe7a09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpiId);
export default __webpack_public_path__ + "static/media/upiId.a2e58d0621ca3fb1fe6ea5ffba17e4b9.svg";
export { ForwardRef as ReactComponent };